export const TOOLTIP_TAG_NAME = "tooltip" as const;

export const TOOLTIP_DELAY_MS = 600;

export const TOOLTIP_CLOSE_DELAY_MS = 0;

export const TOOLTIP_VARIANTS = ["default", "error"] as const;
